export enum ReferralSystemTab {
  PIGGY_BANK = 'piggy-bank',
}
